import React from 'react';

interface TextAreaFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  rows?: number;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  maxLength,
  rows = 4
}) => (
  <textarea
    id={id}
    name={id}
    value={value || ''}
    onChange={onChange}
    placeholder={placeholder}
    disabled={disabled}
    maxLength={maxLength}
    rows={rows}
    className="w-full col-span-full rounded border border-slate-200 px-4 py-2 text-sm text-slate-500 dark:border-slate-600 
        dark:bg-slate-800 dark:text-slate-300 outline-none transition-all focus:border-secondary dark:focus:border-secondary"
  />
);

export default TextAreaField;